// import { baseTable, Config } from 'sdi/components/table';
import { DIV } from 'sdi/components/elements';

import { table } from 'sdi/components/table2';

import { getTableTitle, layerSource, tableQuery } from '../../queries/table';
import {
    selectIssueFromRow,
    tableDispatch,
    //extractAsCSV,
} from '../../events/table';
import debug = require('debug');
// import tr from 'sdi/locale';
// import { addIssueLayer } from '../../events/map';
// import { getLayout } from '../../queries/app';
import {
    //reduceTableButton,
    renderFullTableButton,
    //tableButton,
} from '../buttons';
//import { toggleRenderMapAndTable, toggleRenderTable } from '../../events/app';
import { clearFilters } from '../../events/qa';
import { getLastSelectedIssue, getSelectedLinkedGroup } from '../../queries/qa';
import { renderLinkButtons } from '../sidebar/linked-issues';
//import { makeLabel } from 'sdi/components/button';

const logger = debug('client:component/table');

// const renderExportCSV = makeLabel('export', 2, () => tr.qa('exportTableCsv'));

export const renderCancelFiltersLinked = () =>
    DIV(
        { className: 'table-cancel-filter' },
        renderFullTableButton(() => clearFilters())
    );

const toolbar = () =>
    getTableTitle().map(title =>
        DIV(
            { className: 'table-toolbar', key: 'table-toolbar' },
            DIV({ className: 'table-title' }, title),
            getLastSelectedIssue().chain(i =>
                getSelectedLinkedGroup().map(lg => renderLinkButtons(lg, i.id))
            ),
            renderCancelFiltersLinked()
        )
    );

// const buttonRenderTable = () =>
//     getLayout() !== 'table'
//         ? tableButton(toggleRenderTable)
//         : reduceTableButton(toggleRenderMapAndTable);

// const tableButtons = () => [
//     buttonRenderTable(),
//     renderExportCSV(() => extractAsCSV('issues_table')),
// ];

const render = table(
    //'table-issues',
    tableDispatch,
    tableQuery,
    selectIssueFromRow
    //addIssueLayer //TODO
);

export default () => render(layerSource(), toolbar()); //, tableButtons()); //TODO

logger('loaded');
